import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import Ranking from './components/Ranking';
import HomeFAQ from './components/HomeFAQ';

export default function Home() {
  return (
    <>
      <HeroBanner />
      <CategoryNav />
      <HotRecommend />
      <LatestUpdate />
      <Ranking />
      <HomeFAQ />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "迷妹漫画 - 首页",
            "description": "迷妹漫画提供海量免费漫画资源，涵盖日韩国漫全本免费在线看，支持下拉式滚动阅读。",
            "url": "https://mimei-comic.com",
            "inLanguage": "zh-CN",
            "isPartOf": {
              "@type": "WebSite",
              "name": "迷妹漫画",
              "url": "https://mimei-comic.com",
            },
          }),
        }}
      />
    </>
  );
}